import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import PlusSm from '@/assets/icons/plus-sm.svg';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';

interface NoHiringGoalsProps {
  activeTab: string;
  hireATHiringGoalUrl: string;
}

function NoHiringGoals({ activeTab, hireATHiringGoalUrl }: NoHiringGoalsProps) {
  const intl = useIntl();
  const getNoGoalText = (activeTab: string) => {
    switch (activeTab) {
      case 'past':
        return intl.formatMessage({
          defaultMessage: 'No past goals.',
        });
      case 'scheduled':
        return intl.formatMessage({
          defaultMessage:
            'No scheduled goals. Create a new hiring goal to continue tracking spend.',
        });
      default:
        return intl.formatMessage({
          defaultMessage:
            'No active goals. Create a new hiring goal to continue tracking spend.',
        });
    }
  };

  return (
    <>
      <div className="flex flex-col items-center gap-6 self-stretch rounded-lg bg-white p-12">
        <div className="self-stretch text-center">
          <Typography variant="body1">{getNoGoalText(activeTab)}</Typography>
        </div>
        {activeTab !== 'past' && (
          <Button variant="secondary" asChild>
            <Link to={hireATHiringGoalUrl} target="_blank">
              <img src={PlusSm} alt="Add" />
              <FormattedMessage defaultMessage="Add hiring goal" />
            </Link>
          </Button>
        )}
      </div>
    </>
  );
}

export { NoHiringGoals };
